module.exports = __webpack_public_path__ + "img/LOVAL-Logo.97eefa72.svg";